<template>
  <div class="container-arg">
    <div class="navega">
      <navbarComponentShar buttonText="Voltar" redirectRoute="/" />
    </div>

    <br><br>
<!-- Botão Criar BP -->
  

   <h2>Business Partners</h2>
 <div class="criarBP" v-if="userTipo == 'admin'">
<button @click="mostrarPopup = true" class="botao-criar">Criar BP</button>
 </div>
<!-- Popup Modal -->
<div v-if="mostrarPopup" class="popup-overlay">
  <div class="popup">
    <h3>Criar Business Partner</h3>
    <label>Nome:</label>
    <input v-model="novoBP.nome" type="text" />
    <label>Email:</label>
    <input v-model="novoBP.email" type="email" />
    <div class="botoes-popup">
      <button @click="criarBP">Salvar</button>
      <button @click="mostrarPopup = false">Cancelar</button>
    </div>
  </div>
</div>

    <div class="content">
      <ul class="coach-list">
<li v-for="bp in bpsPaginados" :key="bp.id" class="coach-itens">
        <div class="mentorado">
            <li  @click="verDetalhes(bp)" class="botao-link">
            <p> <i class="fa fa-user-o" aria-hidden="true"></i>
{{ bp.nome }}</p> <br>
            <p> <i class="fa fa-envelope-open-o" aria-hidden="true"></i>
 {{ bp.email }}</p> 
            <br>
            </li>
        </div>
      </li>
    </ul>
          <div class="pagination" v-if="totalPaginas > 1">
      <button @click="paginaAnterior" :disabled="paginaAtual === 1">⬅️ Anterior</button>
      <span>Página {{ paginaAtual }} de {{ totalPaginas }}</span>
      <button @click="proximaPagina" :disabled="paginaAtual === totalPaginas">Próxima ➡️</button>
    </div>
    </div>

  </div>



</template>

<script setup>
import navbarComponentShar from './navbarComponentShar.vue'
import { ref, onMounted, computed } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

const bps = ref([])
const router = useRouter()

const userTipoRaw = localStorage.getItem('userTipo') || ''
const userTipo = ref(userTipoRaw.replace(/['"]+/g, ''))

const carregarBusiness = async () => {
  const res = await axios.get('https://access.risecoachees.com/api/BP/readBusiness.php')
  bps.value = res.data
}

const verDetalhes = (bp) => {
router.push({ name: 'VerCoacheesBP', params: { bpId: bp.id } })
}
const mostrarPopup = ref(false)
const novoBP = ref({ nome: '', email: '' })

const criarBP = async () => {
  try {
    const res = await axios.post('https://access.risecoachees.com/api/BP/createBP.php', novoBP.value);
    console.log('Resposta API:', res.data);
    if (res.data.success) {
      alert('BP criado com sucesso!');
      mostrarPopup.value = false;
      novoBP.value = { nome: '', email: '' };
      carregarBusiness();
    } else {
      alert('Erro ao criar Business Partner: ' + (res.data.message || 'Erro desconhecido'));
    }
  } catch (err) {
    console.error('Erro axios:', err);
    alert('Erro de conexão');
  }
};

const paginaAtual = ref(1)
const itensPorPagina = 3

const totalPaginas = computed(() => Math.ceil(bps.value.length / itensPorPagina))

const bpsPaginados = computed(() => {
  const inicio = (paginaAtual.value - 1) * itensPorPagina
  const fim = inicio + itensPorPagina
  return bps.value.slice(inicio, fim)
})

const paginaAnterior = () => {
  if (paginaAtual.value > 1) paginaAtual.value--
}

const proximaPagina = () => {
  if (paginaAtual.value < totalPaginas.value) paginaAtual.value++
}


onMounted(() => {
  carregarBusiness()
})
</script>

<style scoped>
.navega {
  margin-top: -1%;
  margin-bottom: 1%;
}
.container-arg {
  width: 90%;
  margin: auto;
}

.coach-list {

  flex-wrap: wrap;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  gap: 20px;
}
button{
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-items: center;
}
i{
  padding-right: 2%;
}
ul li{
  list-style: none;
  text-decoration: none;
  
}
.coach-itens {
  flex: 1 1 20%;
  box-sizing: border-box;

}

.mentorado {
  border-radius: 8px;
  padding: 5px;
  text-align: center;
  background-color: #fe8a32;
  margin-bottom: 3%;
  margin: 2%;
  cursor: pointer;
    color: white;
  
}

.botao-link {
  border: none;
  border-radius: 2px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;

  display: grid;
  flex-wrap: wrap;
  color: white;
  justify-content: center;
  line-height: 80%;
    justify-items: center;
    margin-top: 2%;
}
.mentorado:hover{

  color: white;
}
.content{

  width: 50%;
  margin-left: auto;
  margin-right: auto;
  background-color: #e14706;
  padding-top: 1%;
  padding-bottom: 1%; 

}

.botao-criar {
  padding: 10px 20px;
  margin-bottom: 20px;
  background-color: blue;
  color: white;
  border: none;
  cursor: pointer;
  font-weight: bold;
  border-radius: 5px;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);

  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup {
  background: white;
  padding: 30px;
  border-radius: 8px;
  width: 300px;
}
p{
  width: 140%;
}
.popup input {
  width: 100%;
  padding: 8px;
  margin: 8px 0;
}

.botoes-popup {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
}



.criarBP{

display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.pagination {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-between;
}
.pagination button{
  background-color: #0000ff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 2%;
}
span{
  padding: 2%;
}

@media (max-width: 900px) {
  .coach-itens {
    flex: 1 1 45%;
    max-width: 45%;
  }
}

@media (max-width: 600px) {
  .coach-itens {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
</style>
